import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import API from 'services/API';

type UseDisableSystemTemplateMutationArgs = {
  key: SystemTemplates;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseDisableSystemTemplateMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const disableSystemTemplate = ({
  key,
  ...payload
}: UseDisableSystemTemplateMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/automation/system-templates/${key}/disable`,
    payload,
  );
};

const useDisableSystemTemplateMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: disableSystemTemplate,
    ...options,
  });
};

export default useDisableSystemTemplateMutation;
